import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { VisitService } from '../../services/visit.service';
import { ReportService } from '../../services/report-service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export async function initList() {
    let date = new Date();
    filter.set({ criteria: { slaughterYear: date.getFullYear() }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await VisitService.getVisitHistory(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/butcher-visit-history/${item.slaughterDate}`);
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function downloadSlaughterMonthlyTotalsReport() {
    let _filter = get(filter);
    ReportService.exportPdfSlaughterMonthlyTotals(_filter);
}
